import React from "react";

function PrivacyPolicy() {
  return <h1>Política de Privacidad</h1>;
}

export default PrivacyPolicy;
